class Config {
	get getProperties() {
		const env = process.env.REACT_APP_STAGE;
		switch (env) {
			case 'staging':
				return {
					app: {
						name: 'Arizona Leader Admin App',
						key: 'f391c1fa-8f88-4da2-aff2-12e1ac2c5f47',
					},
					api: {
						url: 'https://api-test.arizonaleader.org/api/',
					},
					session: {
						expireTime: 1800,
						waitTime: 60,
					},
				};
				break;
			case 'production':
				return {
					app: {
						name: 'Arizona Leader Admin App',
						key: 'f391c1fa-8f88-4da2-aff2-12e1ac2c5f47',
					},
					api: {
						url: 'https://api.arizonaleader.org/api/',
					},
					session: {
						expireTime: 3600,
						waitTime: 60,
					},
				};
				break;
			default:
				return {
					app: {
						name: 'Arizona Leader Admin App',
						key: 'f391c1fa-8f88-4da2-aff2-12e1ac2c5f47',
					},
					api: {
						url: 'http://localhost:4000/api/',
					},
					session: {
						expireTime: 300,
						waitTime: 60,
					},
				};
				break;
		}
	}
}
const config = new Config();
export default config.getProperties;
